









































































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SwitchWrapper from '@/components/shared/SwitchWrapper.vue'
import { GrupoMaterial, KitOpme, Material } from '@/types/ui/solicitacao-cirurgia'

export type Action = 'editar' | 'clonar' | 'excluir'

type ActionFlags = {
  [key in Action]: boolean
}

interface Props {
  kit: KitOpme;
  actionFlags: Partial<ActionFlags>;
}

@Component({
  components: {
    SwitchWrapper,
  },
})
export default class ComponentKitOpmeCard extends Vue {
  @Prop({ required: true })
  readonly kit: Props['kit'];

  @Prop({ type: Object, default: () => ({}) })
  readonly actionFlags: Props['actionFlags'];

  get grupos() {
    if (!this.kit.grupos) return [undefined]
    return [undefined, ...this.kit.grupos]
  }

  get materiaisAgrupados() {
    return this.grupos.map(grupo => ({
      grupo,
      materiais: this.obterMateriaisPorGrupo(grupo),
    }))
  }

  get existeEspecificidade() {
    return this.kit.materiais.some(m => m.especificidades)
  }

  get columns() {
    return this.existeEspecificidade
      ? 'minmax(150px, 1fr) minmax(50px, 100px) minmax(200px, 1.5fr) minmax(200px, 2fr)'
      : 'minmax(150px, 1fr) minmax(50px, 100px) minmax(200px, 2fr)'
  }

  obterMateriaisPorGrupo(grupo: GrupoMaterial | undefined) {
    return this.kit.materiais.filter(m => m.grupoId === (grupo && grupo.id))
  }

  podeEditarQuantidade(material: Material) {
    return material.medicoPodeAlterarAQuantidade
      && material.quantidadeMinima !== undefined
      && material.quantidadeMaxima !== undefined
  }
}
